<tinymce [config]="config"></tinymce>


<!-- <textarea #textArea [(ngModel)]="value" style="height: 300px;"></textarea> -->